import { UAParser } from 'ua-parser-js';
import scrubRequestData from '@/utilities/sentryScrubber';

export const ignoredStatusCodes = [400, 401, 403, 404, 422, 425, 429];

export const ignoredErrorMessages = [
  'ReportingObserver [deprecation]',
  'Request aborted',
  'Non-Error promise rejection captured',
  'timeout of 30000ms exceeded',
  'timeout exceeded',
  'Network Error',
  'Request failed with empty response',
  'Load failed', // XXX: Ignore iOS cryptic failed fetch response, as we don't get any more details on why the request failed
  'CanceledError',
  'Blocked a frame with origin',
  'Timeout',
  'Bad request',
  'has not joined to the Referral Program yet',
  'Event `ErrorEvent` captured as exception with message `Script error.`',
  'Can\'t find variable: gmo', // Known issue: https://issuetracker.google.com/issues/396043331?pli=1
  'NotSupportedError',
  'Script https://paybis.com/sw.js load failed',
  'Rejected',
];

export const isOldBrowsers = () => {
  const parser = new UAParser(navigator.userAgent);
  const browser = parser.getBrowser();

  if (browser.name === 'Chrome' && browser.major < 109) {
    return true;
  }
  if (browser.name === 'Firefox' && browser.major < 54) {
    return true;
  }
  if (browser.name === 'Safari' && browser.major < 10) {
    return true;
  }
  if (browser.name === 'Opera' && browser.major < 38) {
    return true;
  }
  return false;
};

export const denyUrls = [
  /^safari-extension:\/\//i,
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  // Recaptcha
  /recaptcha\/releases/i,
];

export const filterUnwantedExceptions = (event, hint = {}) => {
  if (isOldBrowsers()) return null;
  // @see https://github.com/getsentry/sentry-javascript/issues/2514#issuecomment-603971338
  const isBrokenTimeoutError = hint.originalException === 'Timeout';
  //Check if the browser is an IE, and if so, return null
  const isInternetExplorer = /MSIE|Trident.*rv:11\./.test(window.navigator.userAgent);
  const response = hint.originalException && hint.originalException.response;

  const isIgnoreByStatuses = response && response.status && ignoredStatusCodes.includes(response.status) || false;

  if (isInternetExplorer || isBrokenTimeoutError || isIgnoreByStatuses) {
    return null;
  }
  const isInstagramWebView = /Instagram/.test(window.navigator.userAgent);

  const { exception } = event ?? {};

  if (exception?.values[0]?.value?.includes('Could not find refreshToken')) {
    return null;
  }

  const autofillCallbackHandlerError = exception?.values[0]?.value?.includes('_AutofillCallbackHandler');
  // check if user agent is Instagram and autofillCallbackHandlerError, if so, return null

  if (isInstagramWebView && autofillCallbackHandlerError) {
    return null;
  }

  // XXX: scrub sensitive data
  if (event.request && event.request.data) {
    event.request.data = scrubRequestData(event.request.data);
  }

  // We want to remove specific error `Cannot read properties of null` that generates by gpay,
  // Because we can't fix it on out side and it not impacted logic. But we should not remove
  // all errors like this.
  if (exception?.values[0]?.value?.includes('Non-Error exception captured with keys')) {
    try {
      const { statusCode, stack, statusMessage } = event.extra.__serialized__.error;
      const isDeveloperError = statusCode === 'DEVELOPER_ERROR';
      const isGooglePayNonErrorException = stack.indexOf('gp/p/js/pay.js') !== -1;
      const isAccessToNullNonErrorException = statusMessage.indexOf('Cannot read properties of null') !== -1;

      if (!isGooglePayNonErrorException) {
        return null;
      }

      if (isGooglePayNonErrorException && !isDeveloperError) {
        return null;
      }
      if (isGooglePayNonErrorException && isAccessToNullNonErrorException) {
        return null;
      }

    } catch (e) { /* empty */ }

  } else if (exception === undefined) {
    return event;
  } else {
    try {
      const firstFrame = exception.values[0].stacktrace.frames[0];
      const isGooglePay = firstFrame.filename.indexOf('gp/p/js/pay.js') !== -1;
      const isAccessToNull = event.message.indexOf('Cannot read properties of null') !== -1;

      if (isGooglePay && isAccessToNull) {
        return null;
      }

    } catch (e) { /* empty */ }
  }

  return event;
};
